import { useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-lg font-bold text-background-50">
            91
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-base font-bold text-foreground-950">91免费版</span>
            <span className="text-[11px] text-foreground-500">下载安装指引中心</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#download"
            className="hidden items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:flex"
          >
            <i className="ri-download-2-line" />
            获取安装包
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between rounded-md px-3 py-3 text-sm text-foreground-700 transition-colors hover:bg-background-100"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-foreground-400" />
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}